<template>
  <v-app>
    <div class="esport-admin-page">
      <header class="navbar">
        <div class="navbar-inner">
          <div class="logo-section">
            <div class="logo-wrapper">
              <img src="/images/icon2.png" alt="logo" class="logo" />
            </div>

            <div>
              <h2>Diskominfo E-Sport <span class="admin-tag">Admin</span></h2>
              <p>Bondowoso Berkah</p>
            </div>
          </div>
        </div>
      </header>

      <main class="esport-container">
        <div class="tab-navigation">
          <button
            class="tab-button"
            :class="{ active: mainTab === 0 }"
            @click="mainTab = 0"
          >
            <span class="tab-icon"><v-icon small>mdi-account-group</v-icon></span>
            <span>
              <strong>Rekap Pendaftar</strong>
              <small>Data peserta</small>
            </span>
          </button>

          <button
            class="tab-button"
            :class="{ active: mainTab === 1 }"
            @click="mainTab = 1"
          >
            <span class="tab-icon"
              ><v-icon small>mdi-calendar-clock-outline</v-icon></span
            >
            <span>
              <strong>Pengaturan Jadwal</strong>
              <small>Buka / tutup lomba</small>
            </span>
          </button>

          <button
            class="tab-button"
            :class="{ active: mainTab === 2 }"
            @click="mainTab = 2"
          >
            <span class="tab-icon"
              ><v-icon small>mdi-file-document-multiple-outline</v-icon></span
            >
            <span>
              <strong>Juknis & Juklak</strong>
              <small>Upload dokumen</small>
            </span>
          </button>

          <button
            class="tab-button"
            :class="{ active: mainTab === 3 }"
            @click="mainTab = 3"
          >
            <span class="tab-icon"><v-icon small>mdi-share-variant-outline</v-icon></span>
            <span>
              <strong>Media Sosial</strong>
              <small>Kelola link</small>
            </span>
          </button>
        </div>

        <template v-if="mainTab === 0">
          <div class="rekap-heading">
            <div>
              <div class="eyebrow">
                <v-icon small> mdi-shield-account-outline </v-icon>
                PANEL ADMIN
              </div>

              <h1>Rekap Pendaftar E-Sport</h1>

              <p>Daftar peserta yang telah melakukan pendaftaran kompetisi.</p>
            </div>

            <div class="header-actions">
              <v-btn
                depressed
                class="export-btn"
                @click="exportExcel"
                :disabled="!rekap.length"
              >
                <v-icon left small>mdi-file-excel-outline</v-icon>
                Export Excel
              </v-btn>

              <v-btn
                depressed
                class="refresh-btn"
                :loading="loadingRekap"
                @click="fetchRekap"
              >
                <v-icon left small> mdi-refresh </v-icon>
                Refresh
              </v-btn>
            </div>
          </div>

          <div class="summary-grid">
            <div class="summary-card total">
              <div class="summary-icon"><v-icon> mdi-account-group </v-icon></div>
              <div>
                <span>Total Pendaftar</span><strong>{{ rekap.length }}</strong>
              </div>
            </div>

            <div class="summary-card slot">
              <div class="summary-icon">
                <v-icon> mdi-ticket-confirmation-outline </v-icon>
              </div>
              <div>
                <span>Total Slot</span><strong>{{ totalSlot }}</strong>
              </div>
            </div>

            <div class="summary-card ai">
              <div class="summary-icon"><v-icon> mdi-robot-outline </v-icon></div>
              <div>
                <span>Lomba AI</span><strong>{{ totalAI }}</strong>
              </div>
            </div>

            <div class="summary-card pes">
              <div class="summary-icon"><v-icon> mdi-soccer </v-icon></div>
              <div>
                <span>Pro Evolution Soccer</span><strong>{{ totalPES }}</strong>
              </div>
            </div>

            <div class="summary-card bukti">
              <div class="summary-icon">
                <v-icon> mdi-image-multiple-outline </v-icon>
              </div>
              <div>
                <span>Bukti Terupload</span
                ><strong>{{ totalBukti }} / {{ totalPES }}</strong>
              </div>
            </div>

            <div class="summary-card menunggu">
              <div class="summary-icon"><v-icon> mdi-clock-outline </v-icon></div>
              <div>
                <span>Menunggu</span><strong>{{ totalMenunggu }}</strong>
              </div>
            </div>

            <div class="summary-card diterima">
              <div class="summary-icon"><v-icon> mdi-check-circle-outline </v-icon></div>
              <div>
                <span>Diterima</span><strong>{{ totalDiterima }}</strong>
              </div>
            </div>

            <div class="summary-card ditolak">
              <div class="summary-icon"><v-icon> mdi-close-circle-outline </v-icon></div>
              <div>
                <span>Ditolak</span><strong>{{ totalDitolak }}</strong>
              </div>
            </div>
          </div>

          <v-card class="modern-card filter-card">
            <div class="filter-header">
              <div>
                <strong>Filter Peserta</strong>
                <span>Cari berdasarkan nama, email, atau nomor WhatsApp.</span>
              </div>

              <v-btn text small class="reset-btn" @click="resetFilter">
                <v-icon left small> mdi-filter-remove-outline </v-icon>
                Reset
              </v-btn>
            </div>

            <div class="filter-grid">
              <v-text-field
                v-model="search"
                outlined
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
                label="Cari nama / email / no. WA"
                class="search-field"
              />

              <div class="competition-filter">
                <button
                  class="filter-chip"
                  :class="{ active: filterJenis === 'ALL' }"
                  @click="filterJenis = 'ALL'"
                >
                  Semua
                </button>

                <button
                  class="filter-chip ai-filter"
                  :class="{ active: filterJenis === 'AI' }"
                  @click="filterJenis = 'AI'"
                >
                  <v-icon left x-small> mdi-robot-outline </v-icon>
                  AI
                </button>

                <button
                  class="filter-chip pes-filter"
                  :class="{ active: filterJenis === 'PRO EVOLUTION SOCCER' }"
                  @click="filterJenis = 'PRO EVOLUTION SOCCER'"
                >
                  <v-icon left x-small> mdi-soccer </v-icon>
                  PES
                </button>
              </div>

              <div class="status-filter">
                <button
                  class="filter-chip"
                  :class="{ active: filterStatus === 'ALL' }"
                  @click="filterStatus = 'ALL'"
                >
                  Semua Status
                </button>

                <button
                  class="filter-chip status-menunggu-filter"
                  :class="{ active: filterStatus === 0 }"
                  @click="filterStatus = 0"
                >
                  <v-icon left x-small>mdi-clock-outline</v-icon> Menunggu
                </button>

                <button
                  class="filter-chip status-diterima-filter"
                  :class="{ active: filterStatus === 1 }"
                  @click="filterStatus = 1"
                >
                  <v-icon left x-small>mdi-check-circle-outline</v-icon> Diterima
                </button>

                <button
                  class="filter-chip status-ditolak-filter"
                  :class="{ active: filterStatus === 2 }"
                  @click="filterStatus = 2"
                >
                  <v-icon left x-small>mdi-close-circle-outline</v-icon> Ditolak
                </button>
              </div>
            </div>

            <div class="filter-result">
              <span>
                Menampilkan <strong>{{ filteredRekap.length }}</strong> pendaftar
              </span>

              <span
                v-if="search || filterJenis !== 'ALL' || filterStatus !== 'ALL'"
                class="filter-active"
              >
                <v-icon x-small> mdi-filter-outline </v-icon>
                Filter aktif
              </span>
            </div>
          </v-card>

          <v-card class="modern-card table-card">
            <div class="table-title">
              <div>
                <strong>Daftar Peserta</strong>
                <span>Data lengkap pendaftaran kompetisi (khusus admin)</span>
              </div>
            </div>

            <v-data-table
              :headers="headers"
              :items="filteredRekap"
              :loading="loadingRekap"
              class="modern-table"
              item-key="id"
              no-data-text="Tidak ada peserta yang sesuai"
              :items-per-page="10"
              :footer-props="{ 'items-per-page-text': 'Data per halaman' }"
            >
              <template v-slot:item.nama_lengkap="{ item }">
                <div class="participant">
                  <div class="participant-avatar">
                    {{ getInitial(item.nama_lengkap) }}
                  </div>
                  <div>
                    <strong>{{ item.nama_lengkap }}</strong>
                    <span>{{ item.email || "-" }}</span>
                  </div>
                </div>
              </template>

              <template v-slot:item.jenis_lomba="{ item }">
                <div
                  class="competition-badge"
                  :class="item.jenis_lomba === 'AI' ? 'ai-badge' : 'pes-badge'"
                >
                  <v-icon small>
                    {{ item.jenis_lomba === "AI" ? "mdi-robot-outline" : "mdi-soccer" }}
                  </v-icon>
                  <span>{{ item.jenis_lomba === "AI" ? "AI" : "PES" }}</span>
                </div>
              </template>

              <template v-slot:item.no_telp="{ item }">
                <a
                  class="phone-number phone-link"
                  :href="waLink(item.no_telp)"
                  target="_blank"
                  rel="noopener"
                  @click.stop
                >
                  <v-icon small> mdi-whatsapp </v-icon>
                  {{ item.no_telp }}
                </a>
              </template>

              <template v-slot:item.jumlah_slot="{ item }">
                <span
                  v-if="item.jenis_lomba === 'PRO EVOLUTION SOCCER'"
                  class="slot-badge"
                >
                  {{ item.jumlah_slot }} Slot
                </span>
                <span v-else class="bukti-na">—</span>
              </template>

              <template v-slot:item.link_video_ai="{ item }">
                <div v-if="item.jenis_lomba === 'AI'">
                  <button
                    v-if="item.link_video_ai"
                    type="button"
                    class="video-thumb"
                    @click="openVideo(item)"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                  </button>

                  <span v-else class="bukti-empty">
                    <v-icon x-small>mdi-video-off-outline</v-icon>
                    Belum ada
                  </span>
                </div>

                <span v-else class="bukti-na">—</span>
              </template>

              <template v-slot:item.nilai_ai="{ item }">
                <div v-if="item.jenis_lomba === 'AI'" class="nilai-cell">
                  <v-text-field
                    v-model="nilaiInputs[item.id]"
                    type="number"
                    step="0.01"
                    dense
                    outlined
                    hide-details
                    class="nilai-input"
                    :disabled="savingNilai === item.id"
                  />
                  <button
                    type="button"
                    class="icon-btn nilai-save-btn"
                    :disabled="savingNilai === item.id"
                    @click="saveNilai(item)"
                  >
                    <v-progress-circular
                      v-if="savingNilai === item.id"
                      indeterminate
                      size="14"
                      width="2"
                    />
                    <v-icon v-else small>mdi-content-save-outline</v-icon>
                  </button>
                </div>
                <span v-else class="bukti-na">—</span>
              </template>

              <template v-slot:item.bukti_pembayaran="{ item }">
                <div v-if="item.jenis_lomba === 'PRO EVOLUTION SOCCER'">
                  <button
                    v-if="buktiUrl(item)"
                    type="button"
                    class="bukti-thumb"
                    @click="openBukti(item)"
                  >
                    <img
                      v-if="buktiIsImage(item)"
                      :src="buktiUrl(item)"
                      alt="Bukti Pembayaran"
                    />
                    <div v-else class="bukti-thumb-pdf">
                      <v-icon>mdi-file-pdf-box</v-icon>
                    </div>
                    <span class="bukti-zoom"
                      ><v-icon small>mdi-magnify-plus-outline</v-icon></span
                    >
                  </button>

                  <span v-else class="bukti-empty">
                    <v-icon x-small>mdi-image-off-outline</v-icon>
                    Belum ada
                  </span>
                </div>

                <span v-else class="bukti-na">—</span>
              </template>

              <template v-slot:item.status_verifikasi="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <button
                      type="button"
                      class="status-chip"
                      :class="`status-${getStatusInfo(item.status_verifikasi).color}`"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="updatingStatus === item.id"
                    >
                      <v-progress-circular
                        v-if="updatingStatus === item.id"
                        indeterminate
                        size="14"
                        width="2"
                      />
                      <v-icon v-else small>{{
                        getStatusInfo(item.status_verifikasi).icon
                      }}</v-icon>
                      {{ getStatusInfo(item.status_verifikasi).label }}
                      <v-icon small>mdi-chevron-down</v-icon>
                    </button>
                  </template>

                  <v-list dense class="status-menu">
                    <v-list-item
                      v-for="opt in statusOptions"
                      :key="opt.value"
                      @click="updateStatusVerifikasi(item, opt.value)"
                    >
                      <v-list-item-icon
                        ><v-icon small :color="opt.color">{{
                          opt.icon
                        }}</v-icon></v-list-item-icon
                      >
                      <v-list-item-title>{{ opt.label }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:item.created_at="{ item }">
                <div class="date-cell">
                  <strong>{{ formatDateOnly(item.created_at) }}</strong>
                  <span>{{ formatTime(item.created_at) }}</span>
                </div>
              </template>

              <template v-slot:item.aksi="{ item }">
                <button
                  type="button"
                  class="icon-btn danger"
                  :disabled="deletingId === item.id"
                  @click="deleteRekap(item)"
                >
                  <v-progress-circular
                    v-if="deletingId === item.id"
                    indeterminate
                    size="14"
                    width="2"
                  />
                  <v-icon v-else small>mdi-trash-can-outline</v-icon>
                </button>
              </template>
            </v-data-table>
          </v-card>
        </template>

        <template v-if="mainTab === 1">
          <div class="section-heading">
            <div class="eyebrow">
              <v-icon small>mdi-calendar-clock-outline</v-icon> JADWAL LOMBA
            </div>
            <h1>Pengaturan Jadwal Pendaftaran</h1>
            <p>Atur tanggal pendaftaran Lomba AI dan Lomba Pro Evolution Soccer.</p>
          </div>

          <div class="jadwal-grid">
            <v-card
              class="modern-card jadwal-card"
              v-for="j in jadwalForms"
              :key="j.jenis_lomba"
            >
              <div
                class="jadwal-card-header"
                :class="j.jenis_lomba === 'AI' ? 'ai' : 'pes'"
              >
                <v-icon>{{
                  j.jenis_lomba === "AI" ? "mdi-robot-outline" : "mdi-soccer"
                }}</v-icon>
                <strong>{{
                  j.jenis_lomba === "AI" ? "Lomba AI" : "Lomba Pro Evolution Soccer"
                }}</strong>
              </div>

              <div class="jadwal-card-body">
                <v-text-field
                  v-model="j.tanggal_acara_mulai"
                  label="Tanggal Acara Mulai"
                  type="date"
                  outlined
                  dense
                  clearable
                />

                <v-text-field
                  v-model="j.tanggal_acara_selesai"
                  label="Tanggal Acara Selesai"
                  type="date"
                  outlined
                  dense
                  clearable
                />

                <v-text-field
                  v-model="j.batas_akhir_pendaftaran"
                  label="Batas Akhir Pendaftaran"
                  type="datetime-local"
                  outlined
                  dense
                />

                <v-select
                  v-model="j.mode_pendaftaran"
                  :items="modeOptions"
                  item-text="label"
                  item-value="value"
                  label="Mode Pendaftaran"
                  outlined
                  dense
                />

                <v-textarea
                  v-model="j.pesan_tutup"
                  label="Pesan saat Ditutup"
                  outlined
                  dense
                  rows="2"
                />

                <v-btn
                  block
                  color="#018c74"
                  class="submit-btn"
                  :loading="j.saving"
                  @click="saveJadwal(j)"
                >
                  <v-icon left small>mdi-content-save-outline</v-icon>
                  Simpan Pengaturan {{ j.jenis_lomba === "AI" ? "AI" : "PES" }}
                </v-btn>
              </div>
            </v-card>
          </div>
        </template>

        <template v-if="mainTab === 2">
          <div class="section-heading">
            <div class="eyebrow">
              <v-icon small>mdi-file-document-multiple-outline</v-icon> DOKUMEN
            </div>
            <h1>Juknis & Juklak</h1>
            <p>Upload dokumen juknis dan juklak</p>
          </div>

          <v-card class="modern-card form-card">
            <div class="form-card-title">
              <strong>{{
                dokumenForm.id ? "Edit Dokumen" : "Upload Dokumen Baru"
              }}</strong>
              <v-btn v-if="dokumenForm.id" text small @click="resetDokumenForm">
                <v-icon left small>mdi-close</v-icon> Batal Edit
              </v-btn>
            </div>

            <div class="form-card-grid">
              <v-select
                v-model="dokumenForm.jenis_lomba"
                :items="[
                  { text: 'AI', value: 'AI' },
                  { text: 'Pro Evolution Soccer', value: 'PRO EVOLUTION SOCCER' },
                ]"
                item-text="text"
                item-value="value"
                label="Lomba *"
                outlined
                dense
              />

              <v-text-field
                v-model="dokumenForm.judul"
                label="Judul Dokumen *"
                outlined
                dense
              />
              <v-text-field
                v-model="dokumenForm.keterangan"
                label="Keterangan (opsional)"
                outlined
                dense
              />

              <v-file-input
                v-model="dokumenForm.file"
                :label="dokumenForm.id ? 'Ganti File (opsional)' : 'File Dokumen (PDF) *'"
                accept="application/pdf,image/*"
                outlined
                dense
                prepend-icon="mdi-paperclip"
              />
            </div>

            <v-btn
              color="#018c74"
              class="submit-btn"
              :loading="dokumenForm.saving"
              @click="submitDokumen"
            >
              <v-icon left small>{{
                dokumenForm.id ? "mdi-content-save-outline" : "mdi-upload-outline"
              }}</v-icon>
              {{ dokumenForm.id ? "Simpan Perubahan" : "Upload Dokumen" }}
            </v-btn>
          </v-card>

          <v-card class="modern-card list-card">
            <div class="table-title">
              <div>
                <strong>Dokumen Lomba AI</strong>
                <span>{{ dokumenAIAll.length }} dokumen</span>
              </div>
            </div>

            <div v-if="!dokumenAIAll.length" class="empty-state">
              Belum ada dokumen untuk lomba AI.
            </div>

            <div
              v-for="doc in dokumenAIAll"
              :key="'row-ai-' + doc.id"
              class="dokumen-row"
            >
              <v-icon color="#018c74">mdi-file-document</v-icon>
              <div class="dokumen-row-info">
                <strong>{{ doc.judul }}</strong>
                <span>{{ doc.keterangan || "-" }}</span>
              </div>
              <v-switch
                :input-value="!!doc.is_active"
                hide-details
                color="#018c74"
                @change="(val) => toggleDokumenActive(doc, val)"
              />
              <button type="button" class="icon-btn" @click="openDokumenPreview(doc)">
                <v-icon small>mdi-eye-outline</v-icon>
              </button>
              <button type="button" class="icon-btn" @click="editDokumen(doc)">
                <v-icon small>mdi-pencil-outline</v-icon>
              </button>
              <button type="button" class="icon-btn danger" @click="deleteDokumen(doc)">
                <v-icon small>mdi-trash-can-outline</v-icon>
              </button>
            </div>
          </v-card>

          <v-card class="modern-card list-card">
            <div class="table-title">
              <div>
                <strong>Dokumen Lomba Pro Evolution Soccer</strong>
                <span>{{ dokumenPESAll.length }} dokumen</span>
              </div>
            </div>

            <div v-if="!dokumenPESAll.length" class="empty-state">
              Belum ada dokumen untuk lomba PES.
            </div>

            <div
              v-for="doc in dokumenPESAll"
              :key="'row-pes-' + doc.id"
              class="dokumen-row"
            >
              <v-icon color="#018c74">mdi-file-document</v-icon>
              <div class="dokumen-row-info">
                <strong>{{ doc.judul }}</strong>
                <span>{{ doc.keterangan || "-" }}</span>
              </div>
              <v-switch
                :input-value="!!doc.is_active"
                hide-details
                color="#018c74"
                @change="(val) => toggleDokumenActive(doc, val)"
              />
              <button type="button" class="icon-btn" @click="openDokumenPreview(doc)">
                <v-icon small>mdi-eye-outline</v-icon>
              </button>
              <button type="button" class="icon-btn" @click="editDokumen(doc)">
                <v-icon small>mdi-pencil-outline</v-icon>
              </button>
              <button type="button" class="icon-btn danger" @click="deleteDokumen(doc)">
                <v-icon small>mdi-trash-can-outline</v-icon>
              </button>
            </div>
          </v-card>
        </template>

        <template v-if="mainTab === 3">
          <div class="section-heading">
            <div class="eyebrow">
              <v-icon small>mdi-share-variant-outline</v-icon> MEDIA SOSIAL
            </div>
            <h1>Link Media Sosial</h1>
            <p>Media sosial resmi esport diskominfo</p>
          </div>

          <v-card class="modern-card form-card">
            <div class="form-card-title">
              <strong>{{ medsosForm.id ? "Edit Link" : "Tambah Link Baru" }}</strong>
              <v-btn v-if="medsosForm.id" text small @click="resetMedsosForm">
                <v-icon left small>mdi-close</v-icon> Batal Edit
              </v-btn>
            </div>

            <div class="form-card-grid">
              <v-text-field
                v-model="medsosForm.nama_platform"
                label="Nama Platform *"
                outlined
                dense
                placeholder="Instagram, YouTube, dll"
              />
              <v-text-field
                v-model="medsosForm.url_medsos"
                label="URL *"
                outlined
                dense
                placeholder="https://..."
              />
              <v-text-field
                v-model="medsosForm.icon"
                label="Icon (opsional)"
                outlined
                dense
                placeholder="mdi-instagram"
              />
              <v-text-field
                v-model.number="medsosForm.urutan"
                label="Urutan"
                type="number"
                outlined
                dense
              />
            </div>

            <v-btn
              color="#018c74"
              class="submit-btn"
              :loading="medsosForm.saving"
              @click="submitMedsos"
            >
              <v-icon left small>{{
                medsosForm.id ? "mdi-content-save-outline" : "mdi-plus"
              }}</v-icon>
              {{ medsosForm.id ? "Simpan Perubahan" : "Tambah Link" }}
            </v-btn>
          </v-card>

          <v-card class="modern-card list-card">
            <div class="table-title">
              <div>
                <strong>Daftar Link Media Sosial</strong
                ><span>{{ medsosAll.length }} link</span>
              </div>
            </div>

            <div v-if="!medsosAll.length" class="empty-state">
              Belum ada link media sosial.
            </div>

            <div v-for="ms in medsosAll" :key="ms.id" class="dokumen-row">
              <v-icon color="#018c74">{{ ms.icon || "mdi-link-variant" }}</v-icon>
              <div class="dokumen-row-info">
                <strong>{{ ms.nama_platform }}</strong>
                <span>{{ ms.url_medsos }}</span>
              </div>

              <span class="urutan-badge">#{{ ms.urutan }}</span>

              <v-switch
                :input-value="!!ms.is_active"
                hide-details
                color="#018c74"
                @change="(val) => toggleMedsosActive(ms, val)"
              />

              <button type="button" class="icon-btn" @click="editMedsos(ms)">
                <v-icon small>mdi-pencil-outline</v-icon>
              </button>
              <button type="button" class="icon-btn danger" @click="deleteMedsos(ms)">
                <v-icon small>mdi-trash-can-outline</v-icon>
              </button>
            </div>
          </v-card>
        </template>
      </main>

      <v-dialog v-model="buktiDialog" max-width="480">
        <v-card class="bukti-dialog-card" v-if="selectedItem">
          <div class="bukti-dialog-header">
            <div>
              <strong>{{ selectedItem.nama_lengkap }}</strong>
              <span>
                Bukti pembayaran
                <template v-if="selectedItem.jenis_lomba === 'PRO EVOLUTION SOCCER'">
                  &middot; {{ selectedItem.jumlah_slot }} Slot
                </template>
              </span>
            </div>

            <v-btn icon small @click="buktiDialog = false"
              ><v-icon small>mdi-close</v-icon></v-btn
            >
          </div>

          <div class="bukti-dialog-body">
            <img
              v-if="buktiIsImage(selectedItem)"
              :src="buktiUrl(selectedItem)"
              alt="Bukti Pembayaran"
              class="bukti-full-img"
            />
            <div v-else class="bukti-pdf-fallback">
              <v-icon large>mdi-file-pdf-box</v-icon>
              <span>File bukti pembayaran berupa dokumen (PDF).</span>
            </div>
          </div>

          <div class="bukti-dialog-footer">
            <a
              :href="buktiUrl(selectedItem)"
              target="_blank"
              rel="noopener"
              class="bukti-open-link"
            >
              <v-icon small left>mdi-open-in-new</v-icon> Buka di tab baru
            </a>
            <a
              :href="buktiUrl(selectedItem)"
              :download="`bukti-${selectedItem.nama_lengkap}`"
              class="bukti-open-link"
            >
              <v-icon small left>mdi-download-outline</v-icon> Unduh
            </a>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="videoDialog" max-width="640">
        <v-card class="dokumen-dialog-card" v-if="selectedVideo">
          <div class="dokumen-dialog-header">
            <div>
              <strong>{{ selectedVideo.nama_lengkap }}</strong>
              <span>Video Hasil Karya Lomba AI</span>
            </div>

            <v-btn icon small @click="videoDialog = false">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="dokumen-dialog-body video-dialog-body">
            <iframe
              v-if="videoEmbedUrl(selectedVideo)"
              :src="videoEmbedUrl(selectedVideo)"
              class="video-frame"
              allow="autoplay; fullscreen"
              allowfullscreen
            ></iframe>

            <div v-else class="dokumen-fallback">
              <v-icon large>mdi-video-off-outline</v-icon>
              <span>Video tidak dapat ditampilkan.</span>
            </div>
          </div>

          <div class="dokumen-dialog-footer">
            <a
              :href="videoOpenUrl(selectedVideo)"
              target="_blank"
              rel="noopener noreferrer"
              class="dokumen-open-link"
            >
              <v-icon small left>mdi-open-in-new</v-icon>
              Buka di tab baru
            </a>

            <a
              :href="videoDownloadUrl(selectedVideo)"
              target="_blank"
              rel="noopener noreferrer"
              class="dokumen-open-link primary"
            >
              <v-icon small left>mdi-download-outline</v-icon>
              Unduh
            </a>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dokumenPreviewDialog" max-width="600">
        <v-card class="dokumen-dialog-card" v-if="selectedDokumenPreview">
          <div class="dokumen-dialog-header">
            <div>
              <strong>{{ selectedDokumenPreview.judul }}</strong>
              <span>
                {{
                  selectedDokumenPreview.jenis_dokumen === "JUKNIS"
                    ? "Petunjuk Teknis"
                    : "Petunjuk Pelaksanaan"
                }}
              </span>
            </div>

            <v-btn icon small @click="dokumenPreviewDialog = false">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="dokumen-dialog-body">
            <img
              v-if="dokumenIsImage(selectedDokumenPreview)"
              :src="selectedDokumenPreview.file_url"
              alt="Preview Dokumen"
              class="dokumen-full-img"
            />

            <iframe
              v-else-if="dokumenIsPdf(selectedDokumenPreview)"
              :src="selectedDokumenPreview.file_url"
              class="dokumen-pdf-frame"
            ></iframe>

            <div v-else class="dokumen-fallback">
              <v-icon large>mdi-file-outline</v-icon>
              <span>Preview tidak tersedia untuk tipe file ini.</span>
            </div>
          </div>

          <div class="dokumen-dialog-footer">
            <a
              :href="selectedDokumenPreview.file_url"
              target="_blank"
              rel="noopener noreferrer"
              class="dokumen-open-link"
            >
              <v-icon small left>mdi-open-in-new</v-icon>
              Buka di tab baru
            </a>

            <a
              :href="selectedDokumenPreview.file_url"
              :download="selectedDokumenPreview.judul"
              class="dokumen-open-link primary"
            >
              <v-icon small left>mdi-download-outline</v-icon>
              Unduh
            </a>
          </div>
        </v-card>
      </v-dialog>


      <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
        {{ snackbar.text }}
      </v-snackbar>
    </div>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import router from "@/router";
import axios from "axios";
import ExcelJS from "exceljs";

const API_BASE = "https://berkah.bondowosokab.go.id:5500";

const ADMIN_API_KEY = "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97";

const authHeaders = {
  headers: { "Bondowoso-Berkah": ADMIN_API_KEY },
};

const authHeadersMultipart = {
  headers: {
    "Bondowoso-Berkah": ADMIN_API_KEY,
    "Content-Type": "multipart/form-data",
  },
};

const mainTab = ref(0);

const dokumenPreviewDialog = ref(false);
const selectedDokumenPreview = ref(null);

const dokumenIsImage = (doc) => {
  if (!doc?.file_url) return false;
  return /\.(png|jpe?g|webp|gif)$/i.test(doc.file_url);
};

const dokumenIsPdf = (doc) => {
  if (!doc?.file_url) return false;
  return /\.pdf$/i.test(doc.file_url);
};

const openDokumenPreview = (doc) => {
  selectedDokumenPreview.value = doc;
  dokumenPreviewDialog.value = true;
};

const snackbar = ref({ show: false, text: "", color: "success" });
const notify = (text, color = "success") => {
  snackbar.value = { show: true, text, color };
};


const rekap = ref([]);
const loadingRekap = ref(false);

const search = ref("");
const filterJenis = ref("ALL");

const buktiDialog = ref(false);
const selectedItem = ref(null);

const updatingStatus = ref(null);
const filterStatus = ref("ALL");
const deletingId = ref(null);

const statusOptions = [
  { value: 0, label: "Menunggu", color: "warning", icon: "mdi-clock-outline" },
  {
    value: 1,
    label: "Terverifikasi",
    color: "success",
    icon: "mdi-check-circle-outline",
  },
  { value: 2, label: "Ditolak", color: "error", icon: "mdi-close-circle-outline" },
];

const getStatusInfo = (status) => {
  return statusOptions.find((s) => s.value === Number(status)) || statusOptions[0];
};

const updateStatusVerifikasi = async (item, newStatus) => {
  if (Number(item.status_verifikasi) === newStatus) return;

  const prevStatus = item.status_verifikasi;
  updatingStatus.value = item.id;
  item.status_verifikasi = newStatus;

  try {
    await axios.put(
      `${API_BASE}/esport/pendaftar/${item.id}/status`,
      { status_verifikasi: newStatus },
      authHeaders
    );
  } catch (err) {
    console.error("Gagal update status verifikasi", err);
    item.status_verifikasi = prevStatus;
    notify("Gagal mengubah status verifikasi.", "error");
  } finally {
    updatingStatus.value = null;
  }
};

const filteredRekap = computed(() => {
  const keyword = search.value.toLowerCase().trim();

  return rekap.value.filter((item) => {
    const nama = String(item.nama_lengkap || "").toLowerCase();
    const noTelp = String(item.no_telp || "").toLowerCase();
    const email = String(item.email || "").toLowerCase();

    const cocokSearch =
      !keyword ||
      nama.includes(keyword) ||
      noTelp.includes(keyword) ||
      email.includes(keyword);

    const cocokJenis =
      filterJenis.value === "ALL" || item.jenis_lomba === filterJenis.value;

    const cocokStatus =
      filterStatus.value === "ALL" ||
      Number(item.status_verifikasi) === Number(filterStatus.value);

    return cocokSearch && cocokJenis && cocokStatus;
  });
});

const totalSlot = computed(() =>
  rekap.value
    .filter((item) => item.jenis_lomba === "PRO EVOLUTION SOCCER")
    .reduce((total, item) => total + Number(item.jumlah_slot || 0), 0)
);

const totalAI = computed(
  () => rekap.value.filter((item) => item.jenis_lomba === "AI").length
);

const totalPES = computed(
  () => rekap.value.filter((item) => item.jenis_lomba === "PRO EVOLUTION SOCCER").length
);

const totalBukti = computed(
  () =>
    rekap.value.filter(
      (item) => item.jenis_lomba === "PRO EVOLUTION SOCCER" && buktiUrl(item)
    ).length
);

const totalMenunggu = computed(
  () => rekap.value.filter((item) => Number(item.status_verifikasi) === 0).length
);
const totalDiterima = computed(
  () => rekap.value.filter((item) => Number(item.status_verifikasi) === 1).length
);
const totalDitolak = computed(
  () => rekap.value.filter((item) => Number(item.status_verifikasi) === 2).length
);

const headers = [
  { text: "Peserta", value: "nama_lengkap", width: "230px" },
  { text: "Jenis Lomba", value: "jenis_lomba", width: "150px" },
  { text: "No. WhatsApp", value: "no_telp", width: "170px" },
  { text: "Slot", value: "jumlah_slot", align: "center", width: "90px" },
  {
    text: "Video AI",
    value: "link_video_ai",
    align: "center",
    width: "110px",
    sortable: false,
  },
  {
    text: "Nilai AI",
    value: "nilai_ai",
    align: "center",
    width: "150px",
    sortable: false,
  },
  {
    text: "Bukti Pembayaran",
    value: "bukti_pembayaran",
    align: "center",
    width: "150px",
    sortable: false,
  },
  {
    text: "Status Verifikasi",
    value: "status_verifikasi",
    align: "center",
    width: "190px",
    sortable: false,
  },
  { text: "Tanggal Daftar", value: "created_at", width: "150px" },
  { text: "Aksi", value: "aksi", align: "center", width: "70px", sortable: false },
];

const nilaiInputs = ref({});
const savingNilai = ref(null);

const fetchRekap = async () => {
  loadingRekap.value = true;
  try {
    const { data } = await axios.get(`${API_BASE}/esport/pendaftar/admin`, authHeaders);
    rekap.value = data?.response?.data || data?.data || [];

    rekap.value.forEach((item) => {
      if (item.jenis_lomba === "AI") {
        nilaiInputs.value[item.id] = item.nilai_ai ?? null;
      }
    });
  } catch (err) {
    console.error("Gagal memuat rekap pendaftar", err);
  } finally {
    loadingRekap.value = false;
  }
};

const saveNilai = async (item) => {
  const nilai = nilaiInputs.value[item.id];

  if (nilai === null || nilai === undefined || nilai === "") {
    notify("Nilai wajib diisi.", "error");
    return;
  }

  savingNilai.value = item.id;
  try {
    await axios.put(`${API_BASE}/esport/nilai-ai/${item.id}`, { nilai }, authHeaders);
    item.nilai_ai = nilai;
    notify(`Nilai untuk "${item.nama_lengkap}" berhasil disimpan.`);
  } catch (err) {
    console.error("Gagal menyimpan nilai", err);
    notify("Gagal menyimpan nilai.", "error");
  } finally {
    savingNilai.value = null;
  }
};

const resetFilter = () => {
  search.value = "";
  filterJenis.value = "ALL";
  filterStatus.value = "ALL";
};

const deleteRekap = async (item) => {
  if (!confirm(`Hapus pendaftar "${item.nama_lengkap}"? Data tidak bisa dikembalikan.`))
    return;

  deletingId.value = item.id;
  try {
    await axios.delete(`${API_BASE}/esport/pendaftar/${item.id}`, authHeaders);
    rekap.value = rekap.value.filter((r) => r.id !== item.id);
    notify("Pendaftar berhasil dihapus.");
  } catch (err) {
    console.error("Gagal menghapus pendaftar", err);
    notify("Gagal menghapus pendaftar.", "error");
  } finally {
    deletingId.value = null;
  }
};


const videoDialog = ref(false);
const selectedVideo = ref(null);

const openVideo = (item) => {
  selectedVideo.value = item;
  videoDialog.value = true;
};

watch(videoDialog, (val) => {
  if (!val) selectedVideo.value = null;
});

const extractGDriveId = (url) => {
  if (!url) return null;
  const patterns = [
    /\/file\/d\/([a-zA-Z0-9_-]+)/,
    /[?&]id=([a-zA-Z0-9_-]+)/,
    /\/d\/([a-zA-Z0-9_-]+)/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m && m[1]) return m[1];
  }
  return null;
};

const videoEmbedUrl = (item) => {
  if (!item) return "";
  if (item.link_video_ai_preview) return item.link_video_ai_preview;
  const id = extractGDriveId(item.link_video_ai);
  return id ? `https://drive.google.com/file/d/${id}/preview` : "";
};

const videoDownloadUrl = (item) => {
  if (!item) return "";
  const id = extractGDriveId(item.link_video_ai);
  return id ? `https://drive.google.com/uc?export=download&id=${id}` : "";
};

const videoOpenUrl = (item) => item?.link_video_ai || "";

const buktiUrl = (item) => {
  if (!item) return "";
  const raw =
    item.bukti_pembayaran_url || item.bukti_pembayaran || item.url_bukti_pembayaran;
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  return `${API_BASE}/${String(raw).replace(/^\/+/, "")}`;
};

const buktiIsImage = (item) => {
  const url = buktiUrl(item);
  if (!url) return false;
  return /\.(png|jpe?g|webp|gif)$/i.test(url);
};

const openBukti = (item) => {
  selectedItem.value = item;
  buktiDialog.value = true;
};

const waLink = (noTelp) => {
  if (!noTelp) return "#";
  let cleaned = String(noTelp).replace(/[^0-9]/g, "");
  if (cleaned.startsWith("0")) {
    cleaned = "62" + cleaned.slice(1);
  } else if (!cleaned.startsWith("62")) {
    cleaned = "62" + cleaned;
  }
  return `https://wa.me/${cleaned}`;
};

const getInitial = (name) => {
  if (!name) return "?";
  return name.trim().charAt(0).toUpperCase();
};

const parseRawDateParts = (dateString) => {
  if (!dateString) return null;
  const match = String(dateString).match(
    /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/
  );
  if (!match) return null;
  const [, year, month, day, hour, minute] = match;
  return { year, month, day, hour, minute };
};

const BULAN_ID = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Agu",
  "Sep",
  "Okt",
  "Nov",
  "Des",
];

const formatDateOnly = (dateString) => {
  const p = parseRawDateParts(dateString);
  if (!p) return "-";
  return `${p.day} ${BULAN_ID[parseInt(p.month, 10) - 1]} ${p.year}`;
};

const formatTime = (dateString) => {
  const p = parseRawDateParts(dateString);
  if (!p) return "";
  return `${p.hour}.${p.minute} WIB`;
};


const exportExcel = async () => {
  if (!filteredRekap.value.length) {
    notify("Tidak ada data yang dapat diekspor.", "error");
    return;
  }

  try {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "Bondowoso Berkah";
    workbook.lastModifiedBy = "Admin E-Sport";
    workbook.created = new Date();
    workbook.modified = new Date();

    const worksheet = workbook.addWorksheet("Rekap Peserta", {
      views: [{ state: "frozen", ySplit: 7 }],
      properties: { defaultRowHeight: 22 },
      pageSetup: {
        orientation: "landscape",
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
        paperSize: 9,
      },
    });

    const PRIMARY = "018C74";
    const PRIMARY_DARK = "006B59";
    const LIGHT_GREEN = "EAF7F4";
    const BORDER = "D9E5E2";
    const TEXT = "263238";
    const MUTED = "64748B";
    const WHITE = "FFFFFF";
    const AI_COLOR = "3B82F6";
    const AI_LIGHT = "EFF6FF";
    const PES_COLOR = "018C74";
    const PES_LIGHT = "ECFDF5";

    worksheet.mergeCells("A1:K1");
    const titleCell = worksheet.getCell("A1");
    titleCell.value = "REKAP PENDAFTAR E-SPORT";
    titleCell.font = { name: "Arial", size: 18, bold: true, color: { argb: WHITE } };
    titleCell.alignment = { vertical: "middle", horizontal: "center" };
    titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: PRIMARY } };
    worksheet.getRow(1).height = 34;

    worksheet.mergeCells("A2:K2");
    const subtitleCell = worksheet.getCell("A2");
    subtitleCell.value = "Diskominfo E-Sport • Bondowoso Berkah";
    subtitleCell.font = { name: "Arial", size: 11, bold: true, color: { argb: PRIMARY } };
    subtitleCell.alignment = { vertical: "middle", horizontal: "center" };
    worksheet.getRow(2).height = 24;

    worksheet.mergeCells("A3:K3");
    const exportDate = new Date();
    const formattedExportDate = exportDate.toLocaleString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
    const exportInfo = worksheet.getCell("A3");
    exportInfo.value = `Diekspor pada: ${formattedExportDate} WIB`;
    exportInfo.font = { name: "Arial", size: 10, italic: true, color: { argb: MUTED } };
    exportInfo.alignment = { vertical: "middle", horizontal: "center" };
    worksheet.getRow(3).height = 22;

    worksheet.mergeCells("A5:B5");
    worksheet.mergeCells("C5:D5");
    worksheet.mergeCells("E5:F5");
    worksheet.mergeCells("G5:H5");

    const summaryData = [
      { range: "A5:B5", label: "TOTAL PENDAFTAR", value: filteredRekap.value.length },
      {
        range: "C5:D5",
        label: "LOMBA AI",
        value: filteredRekap.value.filter((item) => item.jenis_lomba === "AI").length,
      },
      {
        range: "E5:F5",
        label: "LOMBA PES",
        value: filteredRekap.value.filter(
          (item) => item.jenis_lomba === "PRO EVOLUTION SOCCER"
        ).length,
      },
      {
        range: "G5:H5",
        label: "TOTAL SLOT",
        value: filteredRekap.value
          .filter((item) => item.jenis_lomba === "PRO EVOLUTION SOCCER")
          .reduce((total, item) => total + Number(item.jumlah_slot || 0), 0),
      },
    ];

    summaryData.forEach((item) => {
      const cell = worksheet.getCell(item.range.split(":")[0]);
      cell.value = {
        richText: [
          {
            text: `${item.label}\n`,
            font: { name: "Arial", size: 9, bold: true, color: { argb: MUTED } },
          },
          {
            text: String(item.value),
            font: { name: "Arial", size: 16, bold: true, color: { argb: PRIMARY } },
          },
        ],
      };
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: LIGHT_GREEN } };
      cell.border = {
        top: { style: "thin", color: { argb: BORDER } },
        left: { style: "thin", color: { argb: BORDER } },
        bottom: { style: "thin", color: { argb: BORDER } },
        right: { style: "thin", color: { argb: BORDER } },
      };
    });

    worksheet.getRow(5).height = 55;

    worksheet.mergeCells("A6:K6");
    const filterInfo = [];
    if (search.value) filterInfo.push(`Pencarian: "${search.value}"`);
    if (filterJenis.value !== "ALL") filterInfo.push(`Jenis Lomba: ${filterJenis.value}`);
    const filterCell = worksheet.getCell("A6");
    filterCell.value =
      filterInfo.length > 0
        ? `Filter aktif → ${filterInfo.join(" • ")}`
        : "Filter: Semua peserta";
    filterCell.font = { name: "Arial", size: 9, italic: true, color: { argb: MUTED } };
    filterCell.alignment = { vertical: "middle", horizontal: "left" };
    worksheet.getRow(6).height = 20;

    const headersExcel = [
      "No.",
      "Nama Lengkap",
      "Email",
      "No. WhatsApp",
      "Jenis Lomba",
      "Jumlah Slot",
      "Bukti Pembayaran",
      "Link Video AI",
      "Nilai AI",
      "Status Verifikasi",
      "Tanggal Daftar",
    ];
    const headerRow = worksheet.getRow(8);
    headersExcel.forEach((header, index) => {
      const cell = headerRow.getCell(index + 1);
      cell.value = header;
      cell.font = { name: "Arial", size: 10, bold: true, color: { argb: WHITE } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: PRIMARY_DARK } };
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.border = {
        top: { style: "thin", color: { argb: WHITE } },
        left: { style: "thin", color: { argb: WHITE } },
        bottom: { style: "thin", color: { argb: WHITE } },
        right: { style: "thin", color: { argb: WHITE } },
      };
    });
    headerRow.height = 30;

    filteredRekap.value.forEach((item, index) => {
      const rowNumber = index + 9;
      const row = worksheet.getRow(rowNumber);
      const jenisLomba =
        item.jenis_lomba === "PRO EVOLUTION SOCCER" ? "PES" : item.jenis_lomba || "-";
      const jumlahSlot =
        item.jenis_lomba === "PRO EVOLUTION SOCCER" ? Number(item.jumlah_slot || 0) : "-";
      const statusInfo = getStatusInfo(item.status_verifikasi);
      const statusLabel = statusInfo.label;
      const tanggal = item.created_at
        ? `${formatDateOnly(item.created_at)} ${formatTime(item.created_at)}`
        : "-";

      const nilaiTampil =
        item.jenis_lomba === "AI"
          ? item.nilai_ai !== null && item.nilai_ai !== undefined && item.nilai_ai !== ""
            ? Number(item.nilai_ai)
            : "Belum dinilai"
          : "-";

      row.values = [
        index + 1,
        item.nama_lengkap || "-",
        item.email || "-",
        item.no_telp || "-",
        jenisLomba,
        jumlahSlot,
        buktiUrl(item) || "-",
        item.jenis_lomba === "AI" ? (item.link_video_ai ? "Lihat Video" : "-") : "-",
        nilaiTampil,
        statusLabel,
        tanggal,
      ];
      row.height = 28;

      row.eachCell((cell) => {
        cell.font = { name: "Arial", size: 10, color: { argb: TEXT } };
        cell.alignment = { vertical: "middle", wrapText: true };
        cell.border = {
          top: { style: "thin", color: { argb: BORDER } },
          left: { style: "thin", color: { argb: BORDER } },
          bottom: { style: "thin", color: { argb: BORDER } },
          right: { style: "thin", color: { argb: BORDER } },
        };
      });

      if (index % 2 === 1) {
        row.eachCell((cell) => {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F8FBFA" } };
        });
      }

      row.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
      row.getCell(2).font = {
        name: "Arial",
        size: 10,
        bold: true,
        color: { argb: TEXT },
      };

      const phoneCell = row.getCell(4);
      phoneCell.alignment = { vertical: "middle", horizontal: "left" };
      if (item.no_telp) {
        phoneCell.value = { text: String(item.no_telp), hyperlink: waLink(item.no_telp) };
        phoneCell.font = {
          name: "Arial",
          size: 10,
          color: { argb: "128C7E" },
          underline: true,
        };
      }

      const competitionCell = row.getCell(5);
      competitionCell.alignment = { vertical: "middle", horizontal: "center" };
      competitionCell.font = {
        name: "Arial",
        size: 10,
        bold: true,
        color: { argb: item.jenis_lomba === "AI" ? AI_COLOR : PES_COLOR },
      };
      competitionCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: item.jenis_lomba === "AI" ? AI_LIGHT : PES_LIGHT },
      };

      row.getCell(6).alignment = { vertical: "middle", horizontal: "center" };
      if (jumlahSlot !== "-") row.getCell(6).numFmt = "0";

      const buktiCell = row.getCell(7);
      buktiCell.alignment = { vertical: "middle", horizontal: "center" };
      if (buktiUrl(item)) {
        buktiCell.value = { text: "Lihat Bukti", hyperlink: buktiUrl(item) };
        buktiCell.font = {
          name: "Arial",
          size: 10,
          bold: true,
          color: { argb: PRIMARY },
          underline: true,
        };
      } else {
        buktiCell.value = "Belum ada";
        buktiCell.font = {
          name: "Arial",
          size: 10,
          italic: true,
          color: { argb: "94A3B8" },
        };
      }

      const videoCell = row.getCell(8);
      videoCell.alignment = { vertical: "middle", horizontal: "center" };
      if (item.jenis_lomba === "AI" && item.link_video_ai) {
        videoCell.value = { text: "Lihat Video", hyperlink: item.link_video_ai };
        videoCell.font = {
          name: "Arial",
          size: 10,
          bold: true,
          color: { argb: "3B82F6" },
          underline: true,
        };
      } else {
        videoCell.value = item.jenis_lomba === "AI" ? "Belum ada" : "-";
        videoCell.font = {
          name: "Arial",
          size: 10,
          italic: true,
          color: { argb: "94A3B8" },
        };
      }

      const nilaiCell = row.getCell(9);
      nilaiCell.alignment = { vertical: "middle", horizontal: "center" };
      if (item.jenis_lomba === "AI") {
        if (typeof nilaiTampil === "number") {
          nilaiCell.value = nilaiTampil;
          nilaiCell.numFmt = "0.00";
          nilaiCell.font = {
            name: "Arial",
            size: 10,
            bold: true,
            color: { argb: PRIMARY },
          };
          nilaiCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ECFDF5" },
          };
        } else {
          nilaiCell.value = "Belum dinilai";
          nilaiCell.font = {
            name: "Arial",
            size: 10,
            italic: true,
            color: { argb: "94A3B8" },
          };
        }
      } else {
        nilaiCell.value = "-";
        nilaiCell.font = {
          name: "Arial",
          size: 10,
          italic: true,
          color: { argb: "94A3B8" },
        };
      }

      const statusColors = { warning: "D97706", success: "018C74", error: "DC2626" };
      const statusLight = { warning: "FFFBEB", success: "ECFDF5", error: "FEF2F2" };
      const statusCell = row.getCell(10);
      statusCell.alignment = { vertical: "middle", horizontal: "center" };
      statusCell.font = {
        name: "Arial",
        size: 10,
        bold: true,
        color: { argb: statusColors[statusInfo.color] || TEXT },
      };
      statusCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: statusLight[statusInfo.color] || WHITE },
      };

      row.getCell(11).alignment = { vertical: "middle", horizontal: "center" };
    });

    worksheet.columns = [
      { key: "no", width: 7 },
      { key: "nama", width: 28 },
      { key: "email", width: 34 },
      { key: "whatsapp", width: 20 },
      { key: "jenis", width: 18 },
      { key: "slot", width: 13 },
      { key: "bukti", width: 22 },
      { key: "video_ai", width: 20 },
      { key: "nilai_ai", width: 16 },
      { key: "status", width: 18 },
      { key: "tanggal", width: 24 },
    ];

    worksheet.autoFilter = { from: "A8", to: `K${filteredRekap.value.length + 8}` };
    worksheet.headerFooter.oddFooter = "&L&BRekap E-Sport Bondowoso&RPage &P of &N";
    worksheet.pageSetup.printTitlesRow = "8:8";

    const summarySheet = workbook.addWorksheet("Ringkasan");
    summarySheet.mergeCells("A1:D1");
    const summaryTitle = summarySheet.getCell("A1");
    summaryTitle.value = "RINGKASAN PENDAFTAR E-SPORT";
    summaryTitle.font = { name: "Arial", size: 18, bold: true, color: { argb: WHITE } };
    summaryTitle.fill = { type: "pattern", pattern: "solid", fgColor: { argb: PRIMARY } };
    summaryTitle.alignment = { horizontal: "center", vertical: "middle" };
    summarySheet.getRow(1).height = 35;

    summarySheet.mergeCells("A2:D2");
    summarySheet.getCell("A2").value = "Statistik berdasarkan data yang sedang diekspor";
    summarySheet.getCell("A2").font = {
      name: "Arial",
      size: 10,
      italic: true,
      color: { argb: MUTED },
    };
    summarySheet.getCell("A2").alignment = { horizontal: "center" };

    const summaryRows = [
      ["Keterangan", "Jumlah"],
      ["Total Pendaftar", filteredRekap.value.length],
      [
        "Peserta AI",
        filteredRekap.value.filter((item) => item.jenis_lomba === "AI").length,
      ],
      [
        "Peserta PES",
        filteredRekap.value.filter((item) => item.jenis_lomba === "PRO EVOLUTION SOCCER")
          .length,
      ],
      [
        "Total Slot PES",
        filteredRekap.value
          .filter((item) => item.jenis_lomba === "PRO EVOLUTION SOCCER")
          .reduce((total, item) => total + Number(item.jumlah_slot || 0), 0),
      ],
      [
        "Bukti Pembayaran Terupload",
        filteredRekap.value.filter(
          (item) => item.jenis_lomba === "PRO EVOLUTION SOCCER" && buktiUrl(item)
        ).length,
      ],
      [
        "Belum Upload Bukti",
        filteredRekap.value.filter(
          (item) => item.jenis_lomba === "PRO EVOLUTION SOCCER" && !buktiUrl(item)
        ).length,
      ],
      [
        "Rata-rata Nilai AI",
        (() => {
          const nilaiValid = filteredRekap.value
            .filter(
              (item) =>
                item.jenis_lomba === "AI" &&
                item.nilai_ai !== null &&
                item.nilai_ai !== undefined &&
                item.nilai_ai !== ""
            )
            .map((item) => Number(item.nilai_ai));
          return nilaiValid.length
            ? (nilaiValid.reduce((a, b) => a + b, 0) / nilaiValid.length).toFixed(2)
            : "-";
        })(),
      ],
      [
        "Menunggu Verifikasi",
        filteredRekap.value.filter((item) => Number(item.status_verifikasi) === 0).length,
      ],
      [
        "Terverifikasi",
        filteredRekap.value.filter((item) => Number(item.status_verifikasi) === 1).length,
      ],
      [
        "Ditolak",
        filteredRekap.value.filter((item) => Number(item.status_verifikasi) === 2).length,
      ],
    ];

    summaryRows.forEach((data, index) => {
      const row = summarySheet.getRow(index + 4);
      row.values = data;
      row.eachCell((cell) => {
        cell.font = { name: "Arial", size: 11, color: { argb: TEXT } };
        cell.border = {
          top: { style: "thin", color: { argb: BORDER } },
          left: { style: "thin", color: { argb: BORDER } },
          bottom: { style: "thin", color: { argb: BORDER } },
          right: { style: "thin", color: { argb: BORDER } },
        };
        cell.alignment = { vertical: "middle" };
      });

      if (index === 0) {
        row.eachCell((cell) => {
          cell.font = { name: "Arial", size: 11, bold: true, color: { argb: WHITE } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: PRIMARY_DARK },
          };
          cell.alignment = { horizontal: "center", vertical: "middle" };
        });
      } else {
        row.getCell(1).font = {
          name: "Arial",
          size: 11,
          bold: true,
          color: { argb: TEXT },
        };
        row.getCell(2).font = {
          name: "Arial",
          size: 12,
          bold: true,
          color: { argb: PRIMARY },
        };
        row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };

        if (index % 2 === 0) {
          row.eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "F8FBFA" },
            };
          });
        }
      }

      row.height = 27;
    });

    summarySheet.columns = [{ width: 34 }, { width: 20 }, { width: 5 }, { width: 5 }];

    const tanggalFile = new Date().toISOString().slice(0, 10);
    const fileName = `rekap-esport-${tanggalFile}.xlsx`;
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Gagal export Excel:", error);
    notify("Gagal membuat file Excel. Silakan coba lagi.", "error");
  }
};


const modeOptions = [
  { value: "otomatis", label: "Otomatis (ikuti tanggal batas)" },
  { value: "buka_paksa", label: "Buka Paksa (selalu buka)" },
  { value: "tutup_paksa", label: "Tutup Paksa (selalu tutup)" },
];

const defaultJadwal = (jenis) => ({
  jenis_lomba: jenis,
  tanggal_acara_mulai: "",
  tanggal_acara_selesai: "",
  batas_akhir_pendaftaran: "",
  mode_pendaftaran: "otomatis",
  pesan_tutup: "",
  saving: false,
});

const jadwalForms = ref([defaultJadwal("AI"), defaultJadwal("PRO EVOLUTION SOCCER")]);

const toDatetimeLocal = (val) => {
  if (!val) return "";
  return String(val).replace(" ", "T").slice(0, 16);
};

const fetchJadwal = async (jenis) => {
  try {
    const { data } = await axios.get(`${API_BASE}/esport/pengaturan`, {
      ...authHeaders,
      params: { jenis_lomba: jenis },
    });
    const info = data?.response?.data || data?.data || null;
    const target = jadwalForms.value.find((j) => j.jenis_lomba === jenis);
    if (info && target) {
      target.tanggal_acara_mulai = info.tanggal_acara_mulai
        ? String(info.tanggal_acara_mulai).slice(0, 10)
        : "";
      target.tanggal_acara_selesai = info.tanggal_acara_selesai
        ? String(info.tanggal_acara_selesai).slice(0, 10)
        : "";
      target.batas_akhir_pendaftaran = toDatetimeLocal(info.batas_akhir_pendaftaran);
      target.mode_pendaftaran = info.mode_pendaftaran || "otomatis";
      target.pesan_tutup = info.pesan_tutup || "";
    }
  } catch (err) {
    console.error(`Gagal memuat pengaturan ${jenis}`, err);
  }
};


const saveJadwal = async (j) => {
  if (!j.batas_akhir_pendaftaran) {
    notify("Tanggal batas akhir pendaftaran wajib diisi.", "error");
    return;
  }

  j.saving = true;
  try {
    await axios.put(
      `${API_BASE}/esport/pengaturan`,
      {
        jenis_lomba: j.jenis_lomba,
        tanggal_acara_mulai: j.tanggal_acara_mulai || null,
        tanggal_acara_selesai: j.tanggal_acara_selesai || null,
        batas_akhir_pendaftaran: j.batas_akhir_pendaftaran.replace("T", " ") + ":00",
        mode_pendaftaran: j.mode_pendaftaran,
        pesan_tutup: j.pesan_tutup,
      },
      authHeaders
    );
    notify(`Pengaturan ${j.jenis_lomba === "AI" ? "AI" : "PES"} berhasil disimpan.`);
  } catch (err) {
    console.error("Gagal menyimpan jadwal", err);
    notify("Gagal menyimpan pengaturan jadwal.", "error");
  } finally {
    j.saving = false;
  }
};


const dokumenAll = ref([]);

const dokumenAIAll = computed(() =>
  dokumenAll.value.filter((d) => d.jenis_lomba === "AI")
);
const dokumenPESAll = computed(() =>
  dokumenAll.value.filter((d) => d.jenis_lomba === "PRO EVOLUTION SOCCER")
);

const defaultDokumenForm = () => ({
  id: null,
  jenis_lomba: "AI",
  judul: "",
  keterangan: "",
  file: null,
  is_active: true,
  saving: false,
});

const dokumenForm = ref(defaultDokumenForm());

const fetchDokumenAll = async () => {
  try {
    const { data } = await axios.get(`${API_BASE}/esport/dokumen/all`, authHeaders);
    dokumenAll.value = data?.response?.data || data?.data || [];
  } catch (err) {
    console.error("Gagal memuat dokumen", err);
  }
};

const resetDokumenForm = () => {
  dokumenForm.value = defaultDokumenForm();
};

const editDokumen = (doc) => {
  dokumenForm.value = {
    id: doc.id,
    jenis_lomba: doc.jenis_lomba,
    judul: doc.judul,
    keterangan: doc.keterangan || "",
    file: null,
    is_active: !!doc.is_active,
    saving: false,
  };
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const submitDokumen = async () => {
  const f = dokumenForm.value;

  if (!f.judul || !f.jenis_lomba || (!f.id && !f.file)) {
    notify("Judul, lomba, dan file wajib diisi.", "error");
    return;
  }

  f.saving = true;
  try {
    const fd = new FormData();
    fd.append("jenis_lomba", f.jenis_lomba);
    fd.append("judul", f.judul);
    fd.append("keterangan", f.keterangan || "");
    fd.append("is_active", f.is_active ? 1 : 0);
    if (f.file) {
      const file = Array.isArray(f.file) ? f.file[0] : f.file;
      fd.append("file_dokumen", file);
    }

    if (f.id) {
      await axios.put(`${API_BASE}/esport/dokumen/${f.id}`, fd, authHeadersMultipart);
      notify("Dokumen berhasil diperbarui.");
    } else {
      await axios.post(`${API_BASE}/esport/dokumen`, fd, authHeadersMultipart);
      notify("Dokumen berhasil diupload.");
    }

    resetDokumenForm();
    fetchDokumenAll();
  } catch (err) {
    console.error("Gagal menyimpan dokumen", err);
    notify("Gagal menyimpan dokumen.", "error");
  } finally {
    f.saving = false;
  }
};

const toggleDokumenActive = async (doc, val) => {
  const prev = doc.is_active;
  doc.is_active = val ? 1 : 0;
  try {
    const fd = new FormData();
    fd.append("jenis_lomba", doc.jenis_lomba);
    fd.append("judul", doc.judul);
    fd.append("keterangan", doc.keterangan || "");
    fd.append("is_active", val ? 1 : 0);

    await axios.put(`${API_BASE}/esport/dokumen/${doc.id}`, fd, authHeadersMultipart);
    notify(val ? "Dokumen ditampilkan di halaman publik." : "Dokumen disembunyikan.");
  } catch (err) {
    console.error("Gagal update status dokumen", err);
    doc.is_active = prev;
    notify("Gagal mengubah status dokumen.", "error");
  }
};

const deleteDokumen = async (doc) => {
  if (!confirm(`Hapus dokumen "${doc.judul}"?`)) return;
  try {
    await axios.delete(`${API_BASE}/esport/dokumen/${doc.id}`, authHeaders);
    notify("Dokumen berhasil dihapus.");
    fetchDokumenAll();
  } catch (err) {
    console.error("Gagal menghapus dokumen", err);
    notify("Gagal menghapus dokumen.", "error");
  }
};


const medsosAll = ref([]);

const defaultMedsosForm = () => ({
  id: null,
  nama_platform: "",
  url_medsos: "",
  icon: "",
  urutan: 0,
  is_active: true,
  saving: false,
});

const medsosForm = ref(defaultMedsosForm());

const fetchMedsosAll = async () => {
  try {
    const { data } = await axios.get(`${API_BASE}/esport/medsos/all`, authHeaders);
    medsosAll.value = data?.response?.data || data?.data || [];
  } catch (err) {
    console.error("Gagal memuat medsos", err);
  }
};

const resetMedsosForm = () => {
  medsosForm.value = defaultMedsosForm();
};

const editMedsos = (ms) => {
  medsosForm.value = {
    id: ms.id,
    nama_platform: ms.nama_platform,
    url_medsos: ms.url_medsos,
    icon: ms.icon || "",
    urutan: ms.urutan || 0,
    is_active: !!ms.is_active,
    saving: false,
  };
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const submitMedsos = async () => {
  const f = medsosForm.value;

  if (!f.nama_platform || !f.url_medsos) {
    notify("Nama platform dan URL wajib diisi.", "error");
    return;
  }

  f.saving = true;
  try {
    const payload = {
      nama_platform: f.nama_platform,
      url_medsos: f.url_medsos,
      icon: f.icon || null,
      urutan: f.urutan || 0,
      is_active: f.is_active ? 1 : 0,
    };

    if (f.id) {
      await axios.put(`${API_BASE}/esport/medsos/${f.id}`, payload, authHeaders);
      notify("Link media sosial berhasil diperbarui.");
    } else {
      await axios.post(`${API_BASE}/esport/medsos`, payload, authHeaders);
      notify("Link media sosial berhasil ditambahkan.");
    }

    resetMedsosForm();
    fetchMedsosAll();
  } catch (err) {
    console.error("Gagal menyimpan medsos", err);
    notify("Gagal menyimpan link media sosial.", "error");
  } finally {
    f.saving = false;
  }
};

const toggleMedsosActive = async (ms, val) => {
  const prev = ms.is_active;
  ms.is_active = val ? 1 : 0;
  try {
    await axios.put(
      `${API_BASE}/esport/medsos/${ms.id}`,
      {
        nama_platform: ms.nama_platform,
        url_medsos: ms.url_medsos,
        icon: ms.icon || null,
        urutan: ms.urutan || 0,
        is_active: val ? 1 : 0,
      },
      authHeaders
    );
    notify(val ? "Link ditampilkan di halaman publik." : "Link disembunyikan.");
  } catch (err) {
    console.error("Gagal update status medsos", err);
    ms.is_active = prev;
    notify("Gagal mengubah status link.", "error");
  }
};

const deleteMedsos = async (ms) => {
  if (!confirm(`Hapus link "${ms.nama_platform}"?`)) return;
  try {
    await axios.delete(`${API_BASE}/esport/medsos/${ms.id}`, authHeaders);
    notify("Link berhasil dihapus.");
    fetchMedsosAll();
  } catch (err) {
    console.error("Gagal menghapus medsos", err);
    notify("Gagal menghapus link.", "error");
  }
};


const jadwalLoaded = ref(false);

const fetchSemuaJadwal = async () => {
  await Promise.all([fetchJadwal("AI"), fetchJadwal("PRO EVOLUTION SOCCER")]);
  jadwalLoaded.value = true;
};

watch(mainTab, (val) => {
  if (val === 1 && !jadwalLoaded.value) fetchSemuaJadwal();
  if (val === 2 && !dokumenAll.value.length) fetchDokumenAll();
  if (val === 3 && !medsosAll.value.length) fetchMedsosAll();
});

onMounted(() => {
  fetchRekap();
});
</script>

<style scoped>
.esport-admin-page {
  min-height: 100vh;
  background: radial-gradient(
      circle at top right,
      rgba(1, 140, 116, 0.08),
      transparent 35%
    ),
    linear-gradient(135deg, #f5fbfa 0%, #eefbf7 50%, #f8fafc 100%);
  padding-bottom: 60px;
  color: #182433;
}

.navbar {
  position: sticky;
  top: 0;
  z-index: 4;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.navbar-inner {
  max-width: 1240px;
  margin: auto;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-wrapper {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 13px;
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.08);
}

.logo {
  width: 34px;
  height: 34px;
}

.logo-section h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #182433;
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-tag {
  font-size: 10px;
  font-weight: 800;
  color: #018c74;
  background: rgba(1, 140, 116, 0.1);
  padding: 2px 8px;
  border-radius: 6px;
  letter-spacing: 0.4px;
}

.logo-section p {
  margin: 2px 0 0;
  font-size: 11px;
  color: #64748b;
}

.esport-container {
  max-width: 1240px;
  margin: 28px auto;
  padding: 0 20px;
}

.modern-card {
  background: rgba(255, 255, 255, 0.92) !important;
  border: 1px solid rgba(15, 23, 42, 0.06) !important;
  border-radius: 22px !important;
  box-shadow: 0 15px 45px rgba(15, 23, 42, 0.06) !important;
}

.eyebrow {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #018c74;
  margin-bottom: 8px;
}

.tab-navigation {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  padding: 6px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 17px;
  margin-bottom: 22px;
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.05);
}

.tab-button {
  border: 0;
  background: transparent;
  border-radius: 12px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  cursor: pointer;
  color: #64748b;
  transition: 0.2s ease;
}

.tab-button:hover {
  background: #f1f5f9;
}

.tab-button.active {
  background: #ffffff;
  color: #018c74;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
}

.tab-button strong {
  display: block;
  font-size: 12px;
}

.tab-button small {
  display: block;
  margin-top: 1px;
  font-size: 9px;
  color: #94a3b8;
}

.tab-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f5f9;
}

.tab-button.active .tab-icon {
  background: rgba(1, 140, 116, 0.1);
}

.section-heading {
  margin-bottom: 20px;
}

.section-heading h1 {
  margin: 0 0 4px;
  font-size: 26px;
  font-weight: 800;
}

.section-heading p {
  margin: 0;
  color: #64748b;
  font-size: 13px;
}

.rekap-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.rekap-heading h1 {
  margin: 0 0 4px;
  font-size: 28px;
  font-weight: 800;
}

.rekap-heading p {
  margin: 0;
  color: #64748b;
  font-size: 13px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.refresh-btn,
.export-btn {
  border-radius: 11px !important;
  text-transform: none !important;
  color: #018c74 !important;
  background: #ffffff !important;
  border: 1px solid rgba(1, 140, 116, 0.15);
}

.export-btn {
  color: #ffffff !important;
  background: #018c74 !important;
  border: none;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
  margin-bottom: 18px;
}

.summary-card {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 18px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 17px;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.04);
}

.summary-icon {
  width: 43px;
  height: 43px;
  flex: 0 0 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #ffffff;
  color: #ffffff;
}

.summary-card span {
  display: block;
  font-size: 10px;
  color: #94a3b8;
  margin-bottom: 2px;
}

.summary-card strong {
  font-size: 20px;
  line-height: 1;
  color: #1e293b;
}

.summary-card.total .summary-icon {
  color: #6366f1;
  background: #eef2ff;
}
.summary-card.slot .summary-icon {
  color: #f59e0b;
  background: #fffbeb;
}
.summary-card.ai .summary-icon {
  color: #3b82f6;
  background: #eff6ff;
}
.summary-card.pes .summary-icon {
  color: #018c74;
  background: #ecfdf5;
}
.summary-card.bukti .summary-icon {
  color: #d946ef;
  background: #fdf4ff;
}

.filter-card {
  padding: 18px;
  margin-bottom: 18px;
}

.filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.filter-header strong {
  display: block;
  font-size: 14px;
}

.filter-header span {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  color: #94a3b8;
}

.reset-btn {
  text-transform: none !important;
  color: #64748b !important;
}

.filter-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 15px;
  align-items: center;
}

.search-field {
  max-width: 550px;
}

.competition-filter {
  display: flex;
  gap: 7px;
}

.filter-chip {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  border-radius: 10px;
  padding: 8px 13px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: 0.2s;
}

.filter-chip:hover {
  background: #f8fafc;
}

.filter-chip.active {
  background: #018c74;
  color: #ffffff;
  border-color: #018c74;
}
.filter-chip.ai-filter.active {
  background: #3b82f6;
  border-color: #3b82f6;
}
.filter-chip.pes-filter.active {
  background: #018c74;
  border-color: #018c74;
}

.filter-result {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  font-size: 11px;
  color: #94a3b8;
}

.filter-result strong {
  color: #334155;
}

.filter-active {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 8px;
  background: #ecfdf5;
  color: #018c74;
  border-radius: 7px;
  font-weight: 700;
}

.table-card {
  overflow: hidden;
  margin-bottom: 18px;
}

.table-title {
  padding: 18px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.table-title strong {
  display: block;
  font-size: 14px;
}

.table-title span {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.modern-table {
  box-shadow: none !important;
}

.modern-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.modern-table >>> table {
  min-width: 1100px;
}

.modern-table >>> thead th {
  background: #f8fafc !important;
  color: #64748b !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 1px solid #e2e8f0 !important;
}

.modern-table >>> tbody tr:hover {
  background: #f8fffd !important;
}

.modern-table >>> tbody td {
  border-bottom: 1px solid #f1f5f9 !important;
  font-size: 12px;
}

.participant {
  display: flex;
  align-items: center;
  gap: 10px;
}

.participant-avatar {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #e6f7f3;
  color: #018c74;
  font-size: 12px;
  font-weight: 800;
}

.participant strong {
  display: block;
  color: #334155;
  font-size: 12px;
}

.participant span {
  display: block;
  color: #94a3b8;
  font-size: 10px;
  margin-top: 2px;
}

.competition-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 800;
}

.ai-badge {
  background: #eff6ff;
  color: #2563eb;
}
.pes-badge {
  background: #ecfdf5;
  color: #018c74;
}

.phone-number {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #475569;
  font-size: 11px;
}

.phone-link {
  text-decoration: none;
  transition: 0.15s;
}

.phone-link:hover {
  color: #018c74;
}

.phone-number .v-icon {
  color: #22c55e;
}

.slot-badge {
  display: inline-block;
  padding: 5px 9px;
  border-radius: 8px;
  background: #f1f5f9;
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}

.bukti-thumb {
  position: relative;
  width: 52px;
  height: 52px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  padding: 0;
  background: #f8fafc;
}

.bukti-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.bukti-zoom {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.35);
  color: #ffffff;
  opacity: 0;
  transition: 0.15s;
}

.bukti-thumb:hover .bukti-zoom {
  opacity: 1;
}

.bukti-empty {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #cbd5e1;
}

.bukti-na {
  color: #cbd5e1;
  font-size: 12px;
}

.date-cell strong {
  display: block;
  font-size: 11px;
  color: #475569;
}

.date-cell span {
  display: block;
  margin-top: 2px;
  font-size: 10px;
  color: #94a3b8;
}

.bukti-dialog-card {
  border-radius: 18px !important;
  overflow: hidden;
}

.bukti-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #f1f5f9;
}

.bukti-dialog-header strong {
  display: block;
  font-size: 14px;
  color: #1e293b;
}

.bukti-dialog-header span {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.bukti-dialog-body {
  padding: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  min-height: 200px;
}

.bukti-full-img {
  max-width: 100%;
  max-height: 60vh;
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.12);
}

.bukti-pdf-fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 12px;
  padding: 30px;
}

.bukti-dialog-footer {
  display: flex;
  gap: 10px;
  padding: 14px 18px;
  border-top: 1px solid #f1f5f9;
}

.bukti-open-link {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px;
  border-radius: 10px;
  border: 1px solid rgba(1, 140, 116, 0.2);
  color: #018c74;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  transition: 0.15s;
}

.bukti-open-link:hover {
  background: rgba(1, 140, 116, 0.06);
}

.bukti-thumb-pdf {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fef2f2;
  color: #dc2626;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 800;
  border: 1px solid transparent;
  cursor: pointer;
  transition: 0.15s;
}

.status-chip:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.status-warning {
  background: #fffbeb;
  color: #d97706;
  border-color: rgba(217, 119, 6, 0.2);
}
.status-success {
  background: #ecfdf5;
  color: #018c74;
  border-color: rgba(1, 140, 116, 0.2);
}
.status-error {
  background: #fef2f2;
  color: #dc2626;
  border-color: rgba(220, 38, 38, 0.2);
}

.status-menu {
  border-radius: 12px !important;
}

.jadwal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.jadwal-card {
  overflow: hidden;
}

.jadwal-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 18px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 800;
}

.jadwal-card-header.ai {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}
.jadwal-card-header.pes {
  background: linear-gradient(135deg, #018c74, #016a5b);
}

.jadwal-card-body {
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.submit-btn {
  border-radius: 13px !important;
  text-transform: none !important;
  font-size: 13px !important;
  margin-top: 6px;
}

.form-card {
  padding: 20px;
  margin-bottom: 18px;
}

.form-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.form-card-title strong {
  font-size: 14px;
  color: #1e293b;
}

.form-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 16px;
  margin-bottom: 6px;
}

.list-card {
  margin-bottom: 18px;
  overflow: hidden;
}

.empty-state {
  padding: 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 12px;
}

.dokumen-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.dokumen-row:last-child {
  border-bottom: none;
}

.dokumen-row-info {
  flex: 1;
  min-width: 0;
}

.dokumen-row-info strong {
  display: block;
  font-size: 13px;
  color: #1e293b;
}

.dokumen-row-info span {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.urutan-badge {
  font-size: 10px;
  font-weight: 800;
  color: #64748b;
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 7px;
  flex: 0 0 auto;
}

.icon-btn {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 9px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  transition: 0.15s;
}

.icon-btn:hover {
  border-color: #018c74;
  color: #018c74;
}

.icon-btn.danger:hover {
  border-color: #dc2626;
  color: #dc2626;
}

@media (max-width: 1100px) {
  .summary-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .jadwal-grid {
    grid-template-columns: 1fr;
  }
  .form-card-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 900px) {
  .filter-grid {
    grid-template-columns: 1fr;
  }
  .search-field {
    max-width: none;
  }
  .competition-filter {
    flex-wrap: wrap;
  }
  .tab-navigation {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 700px) {
  .esport-container {
    padding: 0 12px;
    margin-top: 18px;
  }
  .navbar-inner {
    padding: 12px;
  }
  .summary-grid {
    grid-template-columns: 1fr 1fr;
    gap: 9px;
  }
  .summary-card {
    padding: 13px;
    gap: 9px;
  }
  .summary-icon {
    width: 37px;
    height: 37px;
    flex: 0 0 37px;
    color: #ffffff;
  }
  .summary-card strong {
    font-size: 17px;
  }
  .summary-card span {
    font-size: 9px;
  }
  .rekap-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .rekap-heading h1 {
    font-size: 23px;
  }
  .header-actions {
    width: 100%;
  }
  .refresh-btn,
  .export-btn {
    flex: 1;
  }
  .filter-header {
    align-items: flex-start;
  }
  .dokumen-row {
    flex-wrap: wrap;
  }
}

@media (max-width: 430px) {
  .summary-grid {
    grid-template-columns: 1fr 1fr;
  }
  .competition-filter {
    width: 100%;
  }
  .filter-chip {
    flex: 1;
    justify-content: center;
  }
  .tab-button small {
    display: none;
  }
}

.dokumen-dialog-card {
  border-radius: 18px !important;
  overflow: hidden;
}

.dokumen-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #f1f5f9;
}

.dokumen-dialog-header strong {
  display: block;
  font-size: 14px;
  color: #1e293b;
}

.dokumen-dialog-header span {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.dokumen-dialog-body {
  padding: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  min-height: 300px;
}

.dokumen-full-img {
  max-width: 100%;
  max-height: 65vh;
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.12);
}

.dokumen-pdf-frame {
  width: 100%;
  height: 65vh;
  border: none;
  border-radius: 10px;
  background: #fff;
}

.dokumen-fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 12px;
  padding: 30px;
}

.dokumen-dialog-footer {
  display: flex;
  gap: 10px;
  padding: 14px 18px;
  border-top: 1px solid #f1f5f9;
}

.dokumen-open-link {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px;
  border-radius: 10px;
  border: 1px solid rgba(1, 140, 116, 0.2);
  color: #018c74;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  transition: 0.15s;
}

.dokumen-open-link:hover {
  background: rgba(1, 140, 116, 0.06);
}

.dokumen-open-link.primary {
  background: #018c74;
  color: #ffffff;
  border-color: #018c74;
}

.dokumen-open-link.primary:hover {
  background: #016a5b;
}

.status-filter {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.filter-chip.status-menunggu-filter.active {
  background: #d97706;
  border-color: #d97706;
}
.filter-chip.status-diterima-filter.active {
  background: #018c74;
  border-color: #018c74;
}
.filter-chip.status-ditolak-filter.active {
  background: #dc2626;
  border-color: #dc2626;
}

.summary-card.menunggu .summary-icon {
  color: #d97706;
  background: #fffbeb;
}
.summary-card.diterima .summary-icon {
  color: #018c74;
  background: #ecfdf5;
}
.summary-card.ditolak .summary-icon {
  color: #dc2626;
  background: #fef2f2;
}

.video-thumb {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid rgba(59, 130, 246, 0.25);
  background: #eff6ff;
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.15s;
}

.video-thumb:hover {
  background: #dbeafe;
  border-color: #3b82f6;
}

.video-thumb .v-icon {
  font-size: 26px;
}

.video-dialog-body {
  padding: 0 !important;
  background: #000 !important;
  min-height: 360px;
}

.video-frame {
  width: 100%;
  height: 360px;
  border: none;
  display: block;
}

.dokumen-subheading {
  padding: 12px 20px 6px;
  font-size: 11px;
  font-weight: 800;
  color: #018c74;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.nilai-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
}

.nilai-input {
  max-width: 78px;
}

.nilai-save-btn {
  flex: 0 0 32px;
}
</style>
